<template>
  <nav
    v-if="blok"
    v-editable="blok"
  >
    <ol role="list">
      <li class="relative pb-10">
        <div class="-ml-px absolute mt-0.5 top-2 left-2 w-0.5 h-full bg-primary" aria-hidden="true" />
        <div class="relative flex items-start group">
          <span class="flex items-center h-4">
            <span class="relative flex items-center justify-center w-4 h-4 rounded-full bg-primary group-hover:bg-indigo-800" />
          </span>
          <span
            :class="blok.theme === 'dark' ? 'text-white' : 'text-dark-900'"
            class="flex flex-col min-w-0 ml-4 -mt-2.5"
          >
            <span class="text-lg font-bold tracking-wide">Today</span>
            <span
              class="text-sm"
              v-html="todayText"
            />
          </span>
        </div>
      </li>

      <li class="relative pb-10">
        <div class="-ml-px absolute mt-0.5 top-2 left-2 w-0.5 h-full bg-primary" aria-hidden="true" />
        <div class="relative flex items-start group">
          <span class="flex items-center h-4">
            <span class="relative flex items-center justify-center w-4 h-4 rounded-full bg-primary group-hover:bg-indigo-800">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-3 h-3 text-primary"
                fill="white"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </span>
          </span>
          <span
            :class="blok.theme === 'dark' ? 'text-white' : 'text-dark-900'"
            class="flex flex-col min-w-0 ml-4 -mt-2.5"
          >
            <span class="text-lg font-bold tracking-wide">{{ formattedNotificationDate }}</span>
            <span
              class="text-sm"
              v-html="reminderText"
            />
          </span>
        </div>
      </li>

      <li class="relative pb-4">
        <div class="-ml-px absolute mt-0.5 top-2 left-2 w-0.5 h-full bg-dark-200" aria-hidden="true" />
        <div class="relative flex items-start group">
          <span class="flex items-center h-3">
            <span class="relative flex items-center justify-center w-4 h-4 rounded-full bg-primary group-hover:bg-indigo-800" />
          </span>
          <span
            :class="blok.theme === 'dark' ? 'text-white' : 'text-dark-900'"
            class="flex flex-col min-w-0 ml-4 -mt-2.5"
          >
            <span class="text-lg font-bold tracking-wide">{{ formattedTrialEndDate }}</span>
            <span
              class="text-sm"
              v-html="startText"
            />
          </span>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import type { AboTimelineStoryblok } from '~/interfaces/storyblok/storyblok'

const props = defineProps<{
  blok: AboTimelineStoryblok
}>()

const todayText = computed<string>(() => {
  return props.blok.today_text ? customRenderRichText(props.blok.today_text) : ''
})

const reminderText = computed<string>(() => {
  return props.blok.reminder_text ? customRenderRichText(props.blok.reminder_text) : ''
})

const startText = computed<string>(() => {
  return props.blok.start_text ? customRenderRichText(props.blok.start_text) : ''
})

const trialEndDate = computed<Date>(() => {
  const trial_days = Number(props.blok.trial_days) || 0
  const currentDate = new Date(Date.now() + trial_days * 24 * 60 * 60 * 1000)
  return currentDate
})

const formattedTrialEndDate = computed<string>(() => {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
  return trialEndDate.value.toLocaleDateString('en-US', options)
})

const notificationDate = computed<Date>(() => {
  const date = trialEndDate.value
  const notificationHeadDays = Number(props.blok.notification_head_days) || 0
  return new Date(date.getTime() - notificationHeadDays * 24 * 60 * 60 * 1000)
})

const formattedNotificationDate = computed<string>(() => {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
  return notificationDate.value.toLocaleDateString('en-US', options)
})
</script>
